import { cn } from '@/utils';

import TextButton from './TextButton';

function TextLink({
	text,
	className,
	onClick,
	linkText,
	linkColor = 'text-red'
}) {
	return (
		<p
			className={cn(
				'mt-4 flex justify-center gap-2 text-center text-xs leading-5 md:mt-6 md:text-sm md:leading-6',
				className
			)}
		>
			<span>{text}</span>
			<TextButton type="button" className={linkColor} onClick={onClick}>
				{linkText}
			</TextButton>
		</p>
	);
}

export default TextLink;
